import React from 'react';

import BaseComponent from 'src/components/BaseComponent';
import { number, remCss, rgba, scssVariables, withRouter } from 'src/helpers';

import model from './model';
import LANG_CONST from 'src/helpers/lang/const';
import { MCButton, MCText, View } from 'src/components/basic';
import MCVirtuoso from 'src/components/complex/MCVirtuoso';
import { BASE_ICONS } from 'src/components/svg';
import moment from 'moment';
import ShortInfo from 'src/components/user/ShortInfo';
import { formatPhoneNumberIntl } from 'react-phone-number-input';

class EarningDetail extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    return (
      <View style={{ height: '100%' }}>
        {this.props.onBack && (
          <View style={{ alignItems: 'flex-end', marginTop: remCss(-40) }}>
            <View style={{ alignItems: 'center', width: remCss(80) }}>
              <MCButton
                onClick={this.props.onBack}
                iconname={BASE_ICONS.BACK_ARROW}
                primary
                width={40}
              />
            </View>
          </View>
        )}
        <MCVirtuoso
          model={model}
          components={{
            Header: () => (
              <>
                {this.props.headerEl}
                <div className={'mc-flex-20 mc-plr10'} style={{ paddingBottom: remCss(20) }}>
                  <MCText label={LANG_CONST.clients} style={{ flex: 1 }} weight={500} />
                  <MCText label={LANG_CONST.serie_invoice} weight={500} />
                  <MCText
                    label={LANG_CONST.date}
                    style={{ textAlign: 'right', maxWidth: remCss(250), width: '20%' }}
                    weight={500}
                  />
                  <MCText
                    label={LANG_CONST.amount}
                    weight={500}
                    style={{ maxWidth: remCss(250), width: '20%', textAlign: 'right' }}
                  />
                </div>
              </>
            )
          }}
          itemContent={(index, item) => {
            return (
              <div
                className={`mc-flex-20  mc-ptb15 mc-plr10`}
                style={{
                  backgroundColor:
                    index % 2 === 0 ? rgba(scssVariables['colors-mc-primary'], 0.05) : 'white'
                }}
              >
                <ShortInfo
                  user={model.state.user?.isPatient ? item.doctor : item.patient}
                  description={
                    !model.state.user?.isPatient &&
                    [
                      item.patient.email,
                      item.patient.phoneNumber
                        ? formatPhoneNumberIntl(item.patient.phoneNumber.toString())
                        : null
                    ]
                      .filter((c) => !!c)
                      .join('/')
                  }
                />
                {item.refundedDate && (
                  <MCText
                    label={LANG_CONST.constants.invoice_status.refunded}
                    primary
                    weight={500}
                    style={{
                      backgroundColor: rgba(scssVariables['colors-mc-primary'], 0.1),
                      paddingVertical: remCss(5),
                      paddingHorizontal: remCss(10),
                      borderRadius: remCss(5)
                    }}
                  />
                )}
                <MCText label={item.serieInvoiceNo} />
                <MCText
                  label={moment(item.paidDate, 'YYYYMMDD').format('DD MMM YYYY')}
                  style={{ textAlign: 'right', maxWidth: remCss(250), width: '20%' }}
                />
                <MCText
                  label={
                    number.format(model.state.user?.isPatient ? item.originAmount : item.amount) +
                    ' ' +
                    item.currency
                  }
                  style={{ maxWidth: remCss(250), width: '20%', textAlign: 'right' }}
                />
              </div>
            );
          }}
        />
      </View>
    );
  }
}

export default withRouter(EarningDetail);
